import { atom } from "recoil";

/**
 * 디바이스 기반 리다이렉트 스킵 여부 상태 (초기값은 false - 리다이렉트 수행)
 */
export const skipDeviceRedirectState = atom<boolean>({
  key: "skipDeviceRedirectState",
  default: false,
});
